import React from 'react';
import './index.css';

import logoDNI from 'assets/images/logo-cuentadnicomercios.gif';
import mobile from 'assets/images/mobile-dnicomercios.png';
import btnGooglePlay from 'assets/images/btn-googleplay.png';
import btnAppStore from 'assets/images/btn-appstore.png';

function Article({ variant }) {

  return (
    <div className={`columns cuentacomercios`}>
      <div className='col col1 centered'>
        <img src={logoDNI} alt="Cuenta DNI Comercios" className='logo-dnicomercios' />
        <div className="intro">
          <p className='strong'>Si sos monotributista o responsable inscripto podes abrir tu cuenta gratis, desde tu celular y cobrar con código QR o link de pago sin costo, durante los primeros 3 meses.</p>
          <h5>Además, si cobrás con la app, participás de promociones exclusivas, a cargo del Banco.</h5>
        </div>
      </div>
      <div className='col col2 centered'>
        <h3>¡Somos más de 8 millones de usuarios/as y más de 100 mil comercios!</h3>
        <p><strong>¡Sumate a nuestra comunidad!</strong></p>
        <a href="/cdniComercios_app/" target='_blank' rel='noreferrer' className='btn-verde'>Ingresar</a>
      </div>
      <div className='col col3 mobile'>
        <img src={mobile} alt="Descargá la aplicación" className='mockup' />
        <h5>Descargá la aplicación</h5>
        <div className='buttons'>
          <a href="https://play.google.com/store/apps/details?id=ar.com.bancoprovincia.CuentaDNIcomercios" target='_blank' rel='noreferrer'>
            <img src={btnGooglePlay} alt='Descarga nuestra aplicación en Android' />
          </a>
          <a href="https://apps.apple.com/ar/app/cuenta-dni-comercios/id1579969604" target='_blank' rel='noreferrer'>
            <img src={btnAppStore} alt='Descarga nuestra aplicación en iOS' />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Article;
